import { render, staticRenderFns } from "./TimeButtons.vue?vue&type=template&id=2c32c88d&scoped=true&"
import script from "./TimeButtons.vue?vue&type=script&lang=js&"
export * from "./TimeButtons.vue?vue&type=script&lang=js&"
import style0 from "./TimeButtons.vue?vue&type=style&index=0&id=2c32c88d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c32c88d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
installComponents(component, {VSpeedDial})
